/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'โฮม',
	myContent: 'เนื้อหาของฉัน',
	teamContent: 'เนื้อหาทีม',
	folder: 'โฟลเดอร์',
	files: 'ไฟล์',
	actionMenu: 'เมนูแอ็คชัน',
	myFolder: 'โฟลเดอร์ของฉัน',

	emptyFolderNoContent: 'ไม่มีเนื้อหา',

	//EmptyStates
	emptyRecentTitle: 'คุณไม่ได้ดูเนื้อหาใด ๆ เมื่อเร็ว ๆ นี้',
	emptyStateTitle: 'เริ่มต้นโดยการเพิ่มข้อมูล',
	emptyStateBody: 'คลิกอัพโหลดข้อมูลข้างบนหรือลากและปล่อยเพื่ออัพโหลดข้อมูล',
	emptySearchResultTitle: 'ขออภัย การค้นหาของคุณไม่ได้ผลลัพธ์ใด ๆ',
	emptyPortalTitle: 'ไม่มีพอร์ทัล',
	emptyPortalBody: 'คุณไม่มีพอร์ทัลใด ๆ ในขณะนี้',
	emptyWsProjectTitle: 'เริ่มต้นโดยการสร้างโน้ตบุ๊กใน Watson Studio',
	emptyWsProjectBody: 'เมื่อคุณกลับไปที่ Cognos Analytics โน้ตบุ๊กของคุณจะปรากฏที่นี่',
	emptyFilteredResultTitle: 'ขออภัย ตัวกรองที่ใช้ไม่ได้ให้ผลลัพธ์ใด ๆ',
	emptyDialogViewTitle: 'ไม่มีไอเท็ม',
	removeFromRecents: 'ลบออกจากที่ผ่านมา',

	// Welcome Banner
	welcomeBannerGreeting: 'สวัสดี ขอต้อนรับสู่ Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics ช่วยให้ผู้ใช้มีการวิเคราะห์แบบให้บริการตนเองโดยขับเคลื่อนด้วย AI ดูวิธีการเตรียมข้อมูลแบบอัตโนมัติ การค้นหาข้อมูล และการแสดงภาพซึ่งสามารถผลักดันให้เกิดการตัดสินใจด้วยความมั่นใจได้มากยิ่งขึ้น',
	welcomeBannerDescription_trialUser: 'คุณสามารถเริ่มต้นได้โดยดูวิดีโอบทนำของเรา การแนะนำผลิตภัณฑ์ และแท็บเริ่มต้นใช้งาน',
	takeTourButtonLabel: 'ดูข้อมูลผลิตภัณฑ์',
	watchVideoButtonLabel: 'ดูวิดีโอ',
	// confirmation dialog
	hideWelcomeBannerMsg: 'คุณแน่ใจว่าต้องการปิดแบนเนอร์ยินดีต้อนรับจากโฮมเพจของคุณ? คุณสามารถเปิดแบนเนอร์ได้อีกครั้งใน โปรไฟล์และการตั้งค่า > การตั้งค่า > ทั่วไป ได้ตลอดเวลา ',
	hideWelcomeBannerTitle: 'ปิดแบนเนอร์ยินดีต้อนรับ',
	ok: 'ตกลง',
	cancel: 'ยกเลิก',
	//howto video dialog
	modal_how_title: 'วิธีการถ่ายวิดีโอ',
	modal_overview_title: 'ดูภาพรวม Cognos Analytics',
	modal_how_play: 'เล่นวิดีโอ',
	modal_how_video_title_overview: 'ภาพรวม',
	modal_how_video_title_getStarted: 'เริ่มต้นใช้งานใน 11.2',
	modal_how_video_title_newUI: 'ขอต้อนรับสู่ประสบการณ์ใหม่ของ Cognos',
	modal_how_video_title_dataModule: 'ภาพรวมของโมดูลข้อมูล',
	modal_how_video_title_explore: 'ภาพรวมของการสำรวจข้อมูล',
	modal_how_video_title_dashboard: 'ภาพรวมของแดชบอร์ดแบบโต้ตอบ',
	modal_how_video_title_reporting: 'ภาพรวมของการรายงาน',
	modal_how_video_title_mobile: 'พลังของ Cognos บนฝ่ามือของคุณ',

	// Toolbar
	search: 'ค้นหา',
	addFolder: 'เพิ่มโฟลเดอร์',
	addLink: 'เพิ่มลิงก์',
	filter: 'ตัวกรอง',
	sort: 'เรียงลำดับ',
	settings: 'การตั้งค่า',
	tilesView: 'มุมมองแบบซ้อน',
	listView: 'มุมมองรายการ',
	columnView: 'มุมมองแบบคอลัมน์',

	// Toolbar Actions
	sortBy: 'เรียงลำดับโดย',
	sortOrder: 'ใบสั่ง',
	name: 'ชื่อ',
	modifiedTime: 'ปรับเปลี่ยน',
	type: 'ชนิด',
	ascending: 'น้อยไปหามาก',
	descending: 'จากมากไปหาน้อย',

	filterType: 'ชนิด',
	filterModificationTime: 'ปรับเปลี่ยน',
	all: 'ทั้งหมด',
	today: 'วันนี้',
	yesterday: 'เมื่อวานนี้',
	pastWeek: 'สัปดาห์ที่ผ่านมา',
	pastMonth: 'เดือนที่ผ่านมา',
	resetFilters: 'รีเซ็ตตัวกรอง',

	filterSearchPlaceHolder: 'กรองตามคีย์เวิร์ด',

	resetFilterTag: 'คลิก X เพื่อรีเซ็ตตัวกรอง',
	filterTagToolTip: 'ใช้ตัวกรอง: %{appliedFilters}',

	folderName: 'ชื่อโฟลเดอร์',
	addAFolder: 'เพิ่มโฟลเดอร์',
	add: 'เพิ่ม',
	error: 'ข้อผิดพลาด',
	newFolderDefaultName: 'สร้างโฟลเดอร์ใหม่',
	toastCreateNewFolder: 'โฟลเดอร์ %{nameOfFolder} ถูกสร้างขึ้นแล้วใน %{tabName}',
	folderAdded: 'เพิ่มโฟลเดอร์แล้ว',
	refresh: 'รีเฟรช',
	openFolder: 'เปิดโฟลเดอร์',

	addAUrl: 'เพิ่ม URL',
	linkName: 'ชื่อ URL',
	linkNamePlaceholder: 'เพิ่มชื่อ URL',
	linkDescription: 'คำอธิบาย (ทางเลือก)',
	linkDescriptionPlaceholder: 'เพิ่มคำอธิบาย',
	linkUri: 'URL',
	linkUriPlaceholder: 'เพิ่ม URL ที่มีโดเมนที่ยอมรับได้',
	acceptableDomains: 'โดเมนที่ยอมรับได้',
	viewAcceptableDomains: 'ดูโดเมนที่ยอมรับได้',
	mandatoryField: 'ฟิลด์บังคับ',
	linkAdded: 'เพิ่ม URL แล้ว',
	toastCreateNewLink: '%{nameOfLink} ถูกเพิ่มไปยัง %{tabName}',
	noEntries: 'ไม่มีรายการในรายการโดเมนที่ยอมรับได้ โปรดติดต่อผู้ดูแลระบบของคุณ',

	compact: 'กะทัดรัด',
	short: 'สั้น',
	default: 'ดีฟอลต์',
	rowSize: 'ขนาดแถว',

	// GroupyByTypes
	folders: 'โฟลเดอร์',
	reports: 'รายงาน',
	dashboards: 'แดชบอร์ด',
	data: 'ข้อมูล',
	packages: 'แพ็กเกจ',
	explorations: 'การสำรวจ',
	stories: 'เรื่องราว',
	notebooks: 'โน้ตบุ๊ก',
	others: 'อื่น ๆ',

	// Error Messages
	itemsOverLimit: 'ชื่อที่ระบุ "%{itemName}" เกินขีดจำกัดสูงสุด (20) โปรดระบุชื่ออื่นเพื่อดำเนินการต่อ',
	errorMessageLengthFolderName: 'โปรดป้อนชื่อโฟลเดอร์ที่ไม่เกิน 255 อักขระ',
	errorMessageLengthLinkName: 'โปรดป้อนชื่อลิงก์ที่มีอักขระไม่เกิน 255 ตัวอักษร',
	toastLaunchPerspectiveError: 'ไม่สามารถเปิด %{objectType}',
	errorNoAccessTitle: 'ขออภัย คุณไม่มีสิทธิเข้าถึงเนื้อหานี้',
	errorNoAccessBody: 'โปรดติดต่อผู้ดูแลระบบของคุณหรืออ้างถึงลิงก์ต่อไปนี้:',
	errorEnableExternalContent: 'การเปิดใช้งานเนื้อหาภายนอก',

	//TableHeader
	lastModified: 'ปรับเปลี่ยนครั้งล่าสุด',
	location: 'ที่ตั้ง',
	tenant: 'ผู้เช่า',

	// GetStartedTab
	getStartedLabel: 'เริ่มต้นและรันใน IBM Cognos Analytics',
	learningHowToLabel: 'รีซอร์สการเรียนรู้',
	learningHowToDescription: 'เพิ่มพูนความรู้ของคุณและรับความช่วยเหลือโดยเชื่อมต่อกับชุมชน อ่านเอกสารคู่มือ และดูวิดีโอ',
	learningHowToActionLabel: 'เรียกใช้บานหน้าต่างการเรียนรู้',
	howToVideosLabel: 'วิดีโอวิธีการ',
	howToVideosDescription: 'ศึกษาวิธีการใช้ IBM Cognos Analytics และเริ่มต้นรับข้อมูลเชิงลึกในข้อมูลของคุณ',
	howToVideosActionLabel: 'ดูวิดีโอ',
	acceleratorCatalogLabel: 'แค็ตตาล็อก Accelerator',
	acceleratorCatalogDescription: 'เรียกดูแค็ตตาล็อกที่เพิ่มขึ้นของการใช้งานอุตสาหกรรม คำแนะนำเกี่ยวกับแนวทางปฏิบัติที่ดีที่สุด การแสดงภาพแบบกำหนดเอง และอื่น ๆ',
	acceleratorCatalogActionLabel: 'เรียกดูแค็ตตาล็อก',
	sampleSectionTitle: 'ตัวอย่าง',
	sampleSectionDescription: 'ทดลองกับตัวอย่างที่แสดงให้เห็นทั้งหมดที่ Cognos Analytics มีให้',
	// Samples Section
	createDashboardSampleTitle: 'วิธีการสร้างแดชบอร์ดแรกของคุณ',
	createDashboardSampleDescription: 'เริ่มต้นการเดินทางวิเคราะห์ข้อมูลของคุณด้วย Cognos Dashboards',
	covid19SampleTitle: 'แดชบอร์ด COVID',
	covid19SampleDescription: 'สำรวจความเป็นไปได้ด้วย Cognos Dashboard นี้ ซึ่งวิเคราะห์ข้อมูลที่เกี่ยวข้องกับ COVID-19 และส่วนขยายที่กำหนดเอง',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'ขยายไลบรารีการแสดงภาพของคุณด้วยการแสดงภาพแบบกำหนดเอง เช่น Sankey Chart',
	viewAllSamplesActionLabel: 'ดูตัวอย่างทั้งหมด',
	byFeatureTitle: 'ตามคุณลักษณะ',
	byFeatureDescription: 'เรียกดูตัวอย่างตามคุณลักษณะ เช่น ฟังก์ชันหลักตัว ตัวควบคุมแบบกำหนดเอง ส่วนขยาย โน้ตบุ๊ก และวันที่ที่เกี่ยวข้อง',
	byIndustryTitle: 'ตามอุตสาหกรรม',
	byIndustryDescription: 'เรียกดูตัวอย่างตามอุตสาหกรรม เช่น ยานยนต์ ธนาคาร และอื่น ๆ',
	// SamplesTab
	sampleTabTitle: 'รับแรงบันดาลใจจากตัวอย่างของเรา',
	sampleTabLabel: 'เยี่ยมชม Accelerator Catalog สำหรับตัวอย่างและส่วนขยายเพิ่มเติมจาก IBM, คู่ค้า และลูกค้า',

	// quickLaunch
	quickLaunchLabel: 'เรียกใช้งานด่วน',
	expand: 'ขยาย',
	collapse: 'ยุบ',

	// quickLaunch dialog
	quickLaunchModalLabel: 'เริ่มต้นโดยเลือกสิ่งที่คุณต้องการสร้าง',

	// contentPageView
	contentPageTitleLabel: 'เนื้อหา',
	uploadFile: 'อัพโหลดข้อมูล',
	new: 'สร้าง',
	create: 'สร้าง',
	more: 'เพิ่มขึ้น',

	// open dialog
	selectDataSourcesToAdd: 'เลือกแหล่งข้อมูลที่จะเพิ่ม',
	openDialogDefaultTitle: 'เปิด',

	// save dialog
	save: 'บันทึก',
	saveAs: 'บันทึกเป็น',
	saving: 'กำลังบันทึก...',
	selectedDestination: 'ปลายทางที่เลือก: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' มีอยู่ก่อนแล้วในชนิดอื่น โปรดเลือกชื่ออื่น',
	confirmOverwriteTitle: 'ยืนยันการเปลี่ยนข้อมูลเดิม',
	confirmOverwriteMsg: 'ไฟล์ \'%{nameOfFile}\' มีอยู่ก่อนแล้ว คุณต้องการแทนที่ข้อมูลด้วยข้อมูลซึ่งมีอยู่ในไฟล์ที่เลือกหรือไม่?',

	// copy move dialog
	copy: 'คัดลอก',
	move: 'ย้าย',
	copyOrMove: 'คัดลอกหรือย้าย: ',
	copyOnly: 'คัดลอก ',
	createShortcut: 'สร้างช็อตคัต',
	createShortcutDialogTitle: 'สร้างช็อตคัต: ',

	// External asset types
	wsProject: 'โปรเจ็กต์ Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'แพ็กเกจ',
	dataModule: 'โมดูลข้อมูล',
	exploration: 'การสำรวจ',
	mode: 'โหมด',
	live: 'สด',
	snapshot: 'สแน็ปช็อต',
	noSnapshotsFound: 'ไม่พบสแน็ปช็อต',
	uploadedFile: 'ไฟล์ที่อัพโหลด',
	fileUpload: 'อัพโหลดข้อมูล',
	dataSetEx: 'ชุดข้อมูล',
	externalRepository: 'ที่เก็บข้อมูลภายนอก',
	queryMode: 'โหมดเคียวรี',
	queryModeCompatible: 'ทำงานร่วมกันได้',
	queryModeDynamic: 'ไดนามิก',
	report: 'รายงาน',
	activeReport: 'รายงานที่แอ็คทีฟ',
	query: 'เคียวรี',
	analysis: 'การวิเคราะห์',
	dashboard: 'แดชบอร์ด',
	dashboardTemplate: 'เท็มเพลตแดชบอร์ด',
	jupyterNotebook: 'โน้ตบุ๊ก',
	wsNotebook: 'โน้ตบุ๊ก Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'เรื่องราว',
	workspace: 'เวิร์กสเปซ',
	pagelet: 'หน้า',
	content: 'เนื้อหา',
	directory: 'เนมสเปซ',
	dataSet: 'ชุดข้อมูล',
	powerPlayCube: 'คิวบ์ PowerPlay',
	powerPlayReport: 'รายงาน PowerPlay',
	powerPlay8Report: 'รายงาน PowerPlay',
	powerPlay8ReportView: 'มุมมองรายงาน PowerPlay',
	reportTemplate: 'เท็มเพลตรายงาน',
	packageConfigurations: 'คอนฟิกูเรชันแพ็กเกจ',
	agent: 'เอเจนต์',
	agentDefinition: 'คำนิยามเอเจนต์',
	agentDefinitionView: 'มุมมองเอเจนต์',
	dataMovementTask: 'ภารกิจการย้ายข้อมูล',
	dataMovementTaskAlias: 'สมนามของภารกิจการย้ายข้อมูล',
	document: 'เอกสาร',
	DocumentRetention: 'คุณสมบัติเอกสาร',
	jobDefinition: 'นิยามงาน',
	job: 'งาน',
	metricsDataSourceETLTask: 'ภารกิจ ETL แหล่งข้อมูลเมทริก',
	metricsExportTask: 'ภารกิจการเอ็กซ์พอร์ตเมทริก',
	metricsFileImportTask: 'ภารกิจการอิมพอร์ตไฟล์เมทริก',
	metricsMaintenanceTask: 'ภารกิจการบำรุงรักษาเมทริก',
	planningTask: 'ภารกิจการวางแผน',
	shortcut: 'ช็อตคัต',
	URL: 'URL',
	launchable: 'เรียกใช้ได้',
	dataSetFolder: 'โฟลเดอร์ชุดข้อมูล',
	ViewAccessibleLabel: 'ดู %{label}',
	overrideReportOptions: 'ลบล้างอ็อพชันรายงานดีฟอลต์',
	formats: 'รูปแบบ',
	saveReport: 'บันทึกรายงาน',
	promptForValues: 'พร้อมต์ให้ฉันเห็น',
	reportView: 'มุมมองรายงาน',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'ข้อมูล Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'รายละเอียด',
	open: 'เปิด',
	created: 'สร้าง',
	modified: 'ปรับเปลี่ยน',
	owner: 'เจ้าของ',
	dataSource: 'แหล่งข้อมูล',
	share: 'แบ่งใช้',
	addToFavorites: 'เพิ่มไปยังรายการโปรด',
	properties: 'คุณสมบัติ',
	detailsEmptyStateBody: 'เลือกไอเท็มที่จะดูรายละเอียด',
	editNameAndDescription: 'แก้ไขชื่อและคำอธิบาย',
	none: 'ไม่มี',

	//rename dialog
	nameInvalid: 'ชื่อไม่ถูกต้อง',
	namePlaceholder: 'ป้อนชื่อ',
	description: 'คำอธิบาย',
	descriptionInvalid: 'คำอธิบายห้ามเกิน 350 อักขระ',
	descriptionPlaceholder: 'ป้อนคำอธิบาย',
	errorMessageApostropheError: 'โปรดป้อนชื่อไฟล์ที่ไม่มีทั้งอักขระ \' และ "',
	renameCollisionError: '%{name} มีอยู่แล้ว โปรดลองใช้ชื่ออื่น',
	unknownRenameError: 'การเปลี่ยนชื่อไอเท็มล้มเหลว โปรดติดต่อผู้ดูแลระบบสำหรับความช่วยเหลือเพิ่มเติม',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'ไม่สามารถเปิดโฟลเดอร์ที่ระบุ',

	//Upload
	uploadToFolder: "อัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "อัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> และเรียกใช้งาน%{launchAction}",
	quickUpload: "อัพโหลดแบบด่วน",
	quickUploadAndLaunch: "ลากและปล่อยไฟล์เพื่ออัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> และเปิดหนึ่งในสเปซต่อไปนี้",
	unsupportedFilesSingle: "%{files} ไม่ได้อัพโหลดเนื่องจากใช้ไม่ได้สำหรับการเรียกใช้งานแบบด่วน",
	unsupportedFilesMultiple: "ไฟล์ไม่ได้อัพโหลดเนื่องจากไฟล์ทั้งหมดที่คุณเลือกต้องใช้ได้สำหรับการเรียกใช้งานด่วน",
	unsupportedFilesSingleInvalid: "%{files} ไม่ถูกต้อง",
	unsupportedFilesMultipleInvalid: "%{files} ไม่ถูกต้อง",
	supportedFileTypes: "อนุญาตให้ใช้ไฟล์ชนิดต่อไปนี้เท่านั้น: %{extensions}",
	uploadDragAndDrop: "ลากและปล่อย",
	uploadDragAndDropMessage: "ลากและปล่อยไฟล์ของคุณที่นี่เพื่ออัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'เกณฑ์การค้นหา \'%{searchTerm}\' ถูกบันทึกแล้ว',
	searchWasntSaved: 'เกณฑ์การค้นหา \'%{searchTerm}\' ยังไม่ถูกบันทึก',
	searchSuggestions: 'ข้อเสนอแนะ',
	savedSearch: 'การค้นหาที่บันทึกไว้',
	searchWasDeleted: 'เกณฑ์การค้นหา \'%{searchTerm}\' ถูกลบแล้ว',
	searchWasntDeleted: 'เกณฑ์การค้นหา \'%{searchTerm}\' ยังไม่ถูกลบ',
	savedBarTitle: 'ค้นหา Cognos Analytics',
	searchContentPageTitle: 'ค้นหา',
	searchContentPageTitleLabel: 'กำลังแสดงผลลัพธ์สำหรับ \'%{searchTerm}\'',
	showingSearchRsult: 'กำลังแสดง %{resultCount} ไอเท็ม',
	saveSearch: 'บันทึกการค้นหา',
	saveTenSearches: 'คุณสามารถบันทึก 10 การค้นหา',
	deleteASearch: 'ลบหนึ่งการค้นหา เพื่อบันทึกการค้นหาอื่น',
	close: 'ปิด',

	//recent view
	recents: 'เมื่อเร็ว ๆ นี้',
	noAccessRecent: 'ไม่มีการเข้าถึง',
	noAccessRecentMsg: 'คุณไม่มีสิทธิ์เข้าถึงกับทรัพยากรนี้ อาจปิดใช้งานอยู่หรือลบออกแล้ว หรือสิทธิ์ของคุณอาจถูกลดลง ตรวจสอบสถานะของทรัพยากรที่ตำแหน่งต้นทางที่ต้องการ คุณสามารถลบสินทรัพย์ออกจากไอเท็มล่าสุดได้โดยการคลิก ตกลง',
	noAccessMsg: 'คุณไม่มีสิทธิ์เข้าถึงกับทรัพยากรนี้ อาจปิดใช้งานอยู่หรือลบออกแล้ว หรือสิทธิ์ของคุณอาจถูกลดลง',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} ไอเท็มที่เลือก',
	itemSelected: '%{nameOfSelection} ไอเท็มที่เลือก'

});